module.exports = __webpack_public_path__ + "img/electric_enabled.dcb11c17.svg";